import { CheckCircle2Icon } from 'lucide-react'

import { formatMoney } from 'utils'
import { type EmployersLastMonthCostItem } from 'utils/web_api.schemas'

interface CostItemProps {
  item: EmployersLastMonthCostItem
}

export function LastMonthCostItem ({ item }: CostItemProps) {
  const total = item.total.subunits / 100
  const isPaid = item.status === 'paid'

  function formatDate (dateString: string): string {
    const date = new Date(dateString)
    const month = date.toLocaleString('en-US', { month: 'short' })
    const day = date.getDate()
    return `${month} ${day}`
  }

  return (
    <div className='flex flex-col gap-1'>
      <div className='flex items-center gap-2'>
        <span className='body-sm text-gray-800'>
          {item.type === 'healthcare_costs' ? 'Healthcare costs' : 'Platform fees'}
        </span>
        <span className='flex-1 border-b border-dotted border-gray-300' />
        <span className='body-sm-bold text-gray-800'>{formatMoney(total)}</span>
      </div>
      <div className='flex items-center justify-between'>
        <span className='body-sm text-gray-500'>
          {formatDate(item.period_start_date)} – {formatDate(item.period_end_date)}
        </span>
        {isPaid && item.paid_at
          ? (
            <span className='flex items-center gap-1 body-sm text-green-400'>
              <CheckCircle2Icon className='w-3 h-3' />
              Paid {formatDate(item.paid_at)}
            </span>
            )
          : (
            <span className='body-sm text-[#d97706]'>Unpaid</span>
            )}
      </div>
    </div>
  )
}
